import StoreContainer from 'store/container';

const getSettings = () => {
  const { settings } = StoreContainer.store.getState();
  return settings;
};

export default {
  getSettings,
};
